import React, { useContext } from 'react';
import P from 'prop-types';
import './styles.css';
import { Produtos } from '../Produtos';
import { GetDiaSemanaLocal, verificaDiasRestricao } from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';

export const ProdutosCategoria = React.memo(function ProdutosCategoria({ categoria, produtos = [] }) {
  const { dadosApp } = useContext(GlobalContext);

  if (dadosApp.DiaSemana === '') dadosApp.DiaSemana = GetDiaSemanaLocal();

  let diasRestricao = verificaDiasRestricao(dadosApp.DiaSemana, categoria);
  let text = '';

  // if (dadosApp.TipoApp === 'MESA') {
  //   diasRestricao.podeVender = true;
  // } else {
  if (!diasRestricao.podeVender) {
    if (diasRestricao.eHoje) text = diasRestricao.horario;
    else text = diasRestricao.dias;
  }
  //}

  return (
    <>
      <h4 className="title-category capitalize">
        {categoria.categoria_ecommerce === ''
          ? categoria.subgrupo.toLowerCase()
          : categoria.categoria_ecommerce.toLowerCase()}
        {!diasRestricao.podeVender && <span style={{ marginLeft: '10px', fontSize: '12px' }}>{text}</span>}
      </h4>
      <div className="row">
        {produtos.map((produto, index) => (
          <Produtos key={index} diasRestricao={diasRestricao} item={{ ...produto }} />
        ))}
      </div>
    </>
  );
});

ProdutosCategoria.propTypes = {
  categoria: P.object.isRequired,
  produtos: P.array.isRequired,
};
